import React from "react";
import { Link, useParams } from "react-router-dom";
import { getPreferredLanguage, localizePath } from "../../utils/languageRouting";

/** Drop-in Link that prefixes the active public language. */
const LangLink = ({ to, ...rest }) => {
  const { lang } = useParams();
  const localizedTo =
    typeof to === "string" ? localizePath(to, lang || getPreferredLanguage()) : to;
  return <Link to={localizedTo} {...rest} />;
};

export default LangLink;
